export default {
  scheduled_order: 'Ordine programmato',
  show_more: 'Mostra altro',
  show_less: 'Mostra meno',
  schedule_order: 'Programma ordine',
};
